import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  hasScrolled: false,
  topLeftText: "",
};

const headerBarSlice = createSlice({
  name: "headerBar",
  initialState,
  reducers: {
    setScrolled: (state, action) => {
      state.hasScrolled = action.payload;
    },
    setTopLeftText: (state, action) => {
      state.topLeftText = action.payload;
    },
    updateTopLeftTextFromPath: (state, action) => {
      const path = action.payload.toString();
      console.log("Current path:", path);
      if (path === "/") {
        state.topLeftText = "Home";
      } else if (path.includes("performance")) {
        state.topLeftText = "Performance";
      } else if (path.includes("/seo")) {
        state.topLeftText = "SEO";
      } else if (path.includes("navigator")) {
        state.topLeftText = "Navigator";
      } else if (path.includes("influencer")) {
        state.topLeftText = "Influencer";
      } else if (path.includes("settings")) {
        state.topLeftText = "Settings";
      } else if (path.includes("bulk-uploader")) {
        state.topLeftText = "Bulk Uploader";
      } else if (path.includes("compass-portal")) {
        state.topLeftText = "Compass Portal";
      } else {
        state.topLeftText = "Legacy Dashboards";
      }
    },
  },
});

export const { setScrolled, setTopLeftText, updateTopLeftTextFromPath } =
  headerBarSlice.actions;
export default headerBarSlice.reducer;
